import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { EnumIroLevelOfImpact, EnumIroOverrideStatus, EnumIroStatus, EnumIroType, useGetIroQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'materiality',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetIroQuery = useGetIroQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetIroQuery.result,
      onResult = _useGetIroQuery.onResult;
    var initStatusOnce = _.once(function (data) {
      var _data$getIro, _data$getIro2, _data$getIro3;
      editing.value = !((_data$getIro = data.getIro) !== null && _data$getIro !== void 0 && _data$getIro.likelihoodReason);
      overrideEditing.value = !((_data$getIro2 = data.getIro) !== null && _data$getIro2 !== void 0 && _data$getIro2.overrideReason) && ((_data$getIro3 = data.getIro) === null || _data$getIro3 === void 0 ? void 0 : _data$getIro3.overrideStatus);
    });
    onResult(function (_ref) {
      var data = _ref.data;
      if (data !== null && data !== void 0 && data.getIro) {
        initStatusOnce(data);
      }
    });
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getIro) || {};
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      onDone = _useUpdateIroMutation.onDone,
      updateIRO = _useUpdateIroMutation.mutate;
    onDone(function (_) {
      window.$nuxt.$emit('userMsg');
    });
    var editing = ref(false);
    var disabled = computed(function () {
      var _result$value2;
      var item = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.getIro;
      if ([EnumIroType.PositiveImpact, EnumIroType.NegativeImpact].includes(item.type)) {
        if (!item.severity || !item.severityReason || !item.likelihood && item.levelOfImpact === EnumIroLevelOfImpact.Potential) {
          return true;
        }
        if (item.status === EnumIroStatus.NotAssessed) {
          return true;
        }
      } else {
        console.log('risk or opportunity!!!!!!');
        // case of risk or opportunity
        return !item.likelihood || !item.magnitude;
      }
      return false;
    });
    var overrideEditing = ref(false);
    return {
      __sfc: true,
      route: route,
      result: result,
      onResult: onResult,
      initStatusOnce: initStatusOnce,
      item: item,
      onDone: onDone,
      updateIRO: updateIRO,
      editing: editing,
      disabled: disabled,
      overrideEditing: overrideEditing,
      EnumIroLevelOfImpact: EnumIroLevelOfImpact,
      EnumIroOverrideStatus: EnumIroOverrideStatus,
      EnumIroType: EnumIroType
    };
  }
});